import React from "react";
import "./_footer.scss";

const Footer = () => (
  <div className="footer tailwind">
    <div className="flex justify-between max-w-xl mx-auto text-sm">
      <p className="text">
        © 2018{" "}
        <a
          href=""
          className="text no-underline"
        >
        Emily Wu.
        </a>
        {" "}All Rights Reserved. 
      </p>
    </div>
  </div>
);

export default Footer;
